webpackJsonp([42411157278704],{

/***/ 1972:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderImportTemplate","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"columns","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"ProviderImportColumn"}}}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"maxBytes","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"maxRows","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-provider-import-template-e8ccda08583a3332008e.js